import { c as _c } from "react/compiler-runtime";
import React from "react";
interface Props<T> {
  items: T[];
  getKey: (item: T, index: number) => React.Key;
  renderItem: (item: T, index: number) => React.ReactNode;
  containerClassName?: string;
  itemClassName?: string;
  gapClassName?: string;
}
export default function HorizontalScrollList(t0) {
  const $ = _c(14);
  const {
    items,
    getKey,
    renderItem,
    containerClassName: t1,
    itemClassName: t2,
    gapClassName: t3
  } = t0;
  const containerClassName = t1 === undefined ? "" : t1;
  const itemClassName = t2 === undefined ? "" : t2;
  const gapClassName = t3 === undefined ? "gap-4" : t3;
  if (!items?.length) {
    return null;
  }
  const t4 = `flex ${gapClassName} overflow-x-auto pt-3 pb-2 hiddenScroll ${containerClassName}`;
  let t5;
  if ($[0] !== t4) {
    t5 = t4.trim();
    $[0] = t4;
    $[1] = t5;
  } else {
    t5 = $[1];
  }
  let t6;
  if ($[2] !== getKey || $[3] !== itemClassName || $[4] !== items || $[5] !== renderItem) {
    let t7;
    if ($[7] !== getKey || $[8] !== itemClassName || $[9] !== renderItem) {
      t7 = (item, index) => <div key={getKey(item, index)} className={itemClassName || undefined}>{renderItem(item, index)}</div>;
      $[7] = getKey;
      $[8] = itemClassName;
      $[9] = renderItem;
      $[10] = t7;
    } else {
      t7 = $[10];
    }
    t6 = items.map(t7);
    $[2] = getKey;
    $[3] = itemClassName;
    $[4] = items;
    $[5] = renderItem;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[11] !== t5 || $[12] !== t6) {
    t7 = <div className={t5}>{t6}</div>;
    $[11] = t5;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  return t7;
}